const wholesaleProducts = [
  {
    id: 1,
    name: 'Bhut Jolokia',
    category: 'Red Chillies',
    description: 'Extremely hot Bhut Jolokia chillies with fruity-smoky undertones, sourced for premium heat products, spice extracts, and industrial chilli blending.',
    image: '/img/bhut1.png',
    images: [
      '/img/bhut1.png',
      '/img/bhut2.jpg',
    ],
  },
  {
    id: 2,
    name: 'Dalle Khorsani',
    category: 'Red Chillies',
    description: 'Round, high-pungency Dalle Khorsani chillies valued for intense heat and bold aroma, suitable for pickles, sauces, and specialty regional blends.',
    image: '/img/dalle1.webp',
    images: [
      '/img/dalle1.webp',
      '/img/dalle2.webp',
    ],
  },
  {
    id: 3,
    name: 'Birds Eye Chilli',
    category: 'Red Chillies',
    description: 'Compact bird’s eye chillies offering sharp, fast-rising heat and vivid red color, ideal for seasoning mixes, flakes, and export-oriented spice packs.',
    image: '/img/bec1.jpg',
    images: [
      '/img/bec1.jpg',
      '/img/bec2.jpg'
    ],
  },
  {
    id: 4,
    name: 'Hathei Chilli',
    category: 'Red Chillies',
    description: 'Distinct Hathei chillies selected for consistent pungency and clean drying quality, suited for grinding, whole chilli supply, and commercial masala use.',
    image: '/img/hc1.jpg',
    images: [
      '/img/hc1.jpg',
      '/img/hc2.jpg',
    ],
  },
  {
    id: 5,
    name: 'Tejas',
    category: 'Red Chillies',
    description: 'Tejas chillies known for bright red appearance and dependable heat profile, preferred for chilli powder production and color-rich spice formulations.',
    image: '/img/tc2.jpg',
    images: [
      '/img/tc2.jpg',
      '/img/tc1.jpg'
    ],
  },
  {
    id: 6,
    name: 'S10',
    category: 'Red Chillies',
    description: 'S10 chillies with strong pungency and robust skin quality, widely used in bulk grinding, oleoresin extraction, and high-volume food manufacturing.',
    image: '/img/s101.jpg',
    images: [
      '/img/s101.jpg',
      '/img/s102.jpg'
    ],
  },
  {
    id: 7,
    name: 'Black Turmeric',
    category: 'Turmeric',
    description: 'Rare black turmeric rhizomes with deep earthy aroma and traditional value, sourced for niche wellness applications and specialty ingredient demand.',
    image: '/img/bt1.jpg',
    images: [
      '/img/bt1.jpg',
      '/img/bt1.png',
    ],
  },
  {
    id: 8,
    name: 'Lakadong Turmeric',
    category: 'Turmeric',
    description: 'High-curcumin Lakadong turmeric with rich golden tone and potent profile, ideal for premium turmeric processing, health-focused products, and export buyers.',
    image: '/img/lt.jpg',
    images: [
      '/img/lt.jpg',
      '/img/lt2.jpg',
    ],
  },
  {
    id: 9,
    name: 'Dry Turmeric',
    category: 'Turmeric',
    description: 'Clean, well-dried turmeric fingers suitable for powder mills and bulk spice operations, offering stable color, aroma, and processing consistency.',
    image: '/img/dt2.jpg',
    images: [
      '/img/dt2.jpg',
      '/img/dt1.jpg',
    ],
  },
  {
    id: 10,
    name: 'Kashmiri Saffron',
    category: 'Saffron',
    description: 'Premium Kashmiri saffron strands with strong aroma, rich coloring strength, and high purity, curated for luxury culinary, gifting, and specialty channels.',
    image: '/img/ks1.jpg',
    images: [
      '/img/ks1.jpg',
      '/img/ks2.jpg'
    ],
  },
  {
    id: 11,
    name: 'Black Cardamom',
    category: 'Cardamom',
    description: 'Smoky black cardamom pods with intense camphor-like aroma, preferred for robust gravies, pulao blends, and large-scale spice manufacturing.',
    image: '/img/bc1.jpg',
    images: [
      '/img/bc1.jpg',
      '/img/bc2.jpg',
    ],
  },
  {
    id: 12,
    name: 'Green Cardamom',
    category: 'Cardamom',
    description: 'Hand-selected green cardamom with bright pods and high essential oil content, ideal for tea blends, sweets, and premium spice retail repacking.',
    image: '/img/gc1.jpg',
    images: [
      '/img/gc1.jpg',
      '/img/gc2.jpg',
    ],
  },
  {
    id: 13,
    name: 'Black Ginger',
    category: 'Ginger',
    description: 'Specialty black ginger with concentrated bioactive profile and earthy pungency, supplied for traditional formulations and value-added ingredient markets.',
    image: '/img/bg1.jpg',
    images: [
      '/img/bg1.jpg',
      '/img/bg2.jpg'
    ],
  },
  {
    id: 14,
    name: 'Fenugreek',
    category: 'Seeds & Spices',
    description: 'Uniform fenugreek seeds with characteristic bittersweet notes, suited for curry bases, pickling, seasoning blends, and commercial spice packs.',
    image: '/img/fg1.jpg',
    images: [
      '/img/fg1.jpg',
      '/img/fg2.jpg'
    ],
  },
  {
    id: 15,
    name: 'Mustard',
    category: 'Seeds & Spices',
    description: 'Quality mustard seeds with clean pungency and oil-rich composition, ideal for tempering, condiment production, and bulk culinary processing.',
    image: '/img/ms1.jpg',
    images: [
      '/img/ms1.jpg',
      '/img/ms2.jpg',
    ],
  },
  {
    id: 16,
    name: 'Posto / Khas Khas',
    category: 'Seeds & Spices',
    description: 'Fresh poppy seeds with mild nutty flavor and smooth texture, used in premium gravies, confectionery applications, and specialty regional cuisines.',
    image: '/img/kk1.jpg',
    images: [
      '/img/kk1.jpg',
      '/img/kk2.jpg',
    ],
  },
  {
    id: 17,
    name: 'Cumin',
    category: 'Seeds & Spices',
    description: 'Aromatic cumin seeds featuring warm earthy notes and reliable volatile oil content, essential for masala making and large-batch food production.',
    image: '/img/cc1.jpg',
    images: [
      '/img/cc1.jpg',
      '/img/cc2.jpg',
    ],
  },
  {
    id: 18,
    name: 'Coriander',
    category: 'Seeds & Spices',
    description: 'Coriander seeds with citrusy sweetness and balanced aroma, suitable for ground spice manufacture, curry blends, and export-grade spice assortments.',
    image: '/img/co1.jpg',
    images: [
      '/img/co1.jpg',
      '/img/co2.jpg',
    ],
  },
  {
    id: 19,
    name: 'Bay Leaves',
    category: 'Seeds & Spices',
    description: 'Dried bay leaves with woody-herbal fragrance and clean cut quality, widely used for rice dishes, gravies, stocks, and institutional kitchens.',
    image: '/img/bl1.jpg',
    images: [
      '/img/bl1.jpg',
      '/img/bl2.png',
    ],
  },
  {
    id: 20,
    name: 'Cloves',
    category: 'Seeds & Spices',
    description: 'High-aroma cloves with strong eugenol character and bold warming taste, selected for spice blends, bakery use, and value-added essential products.',
    image: '/img/cl1.jpg',
    images: [
      '/img/cl1.jpg',
      '/img/cl2.png',
    ],
  },
  {
    id: 21,
    name: 'Indian Black Pepper',
    category: 'Seeds & Spices',
    description: 'Indian black pepper with sharp heat and complex woody-citrus notes, suitable for grinding, seasoning formulations, and premium export markets.',
    image: '/img/ibp.jpg',
    images: [
      '/img/ibp.jpg',
      '/img/ibp2.jpg',
    ],
  },
  {
    id: 22,
    name: 'Dry Ginger',
    category: 'Ginger',
    description: 'Sun-dried ginger with concentrated pungency and warm aroma, ideal for spice milling, beverage mixes, herbal preparations, and culinary manufacturing.',
    image: '/img/dg1.jpg',
    images: [
      '/img/dg1.jpg',
      '/img/dg2.jpg',
    ],
  },

];

export default wholesaleProducts;
